// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Npel","top":"styles_top__2cnYw"};